import React, { Component } from 'react'
import paginateUtil from '../utils/paginate.util'
import PaginateBox, { PaginateBoxPage } from './PaginateBox'

interface PaginatorProps {
  active: number
  total: number
  onPaginate: (page: number) => void
}

export default class Paginator extends Component<PaginatorProps> {
  constructor (props: PaginatorProps) {
    super(props)
    this.handlePaginate = this.handlePaginate.bind(this)
  }

  handlePaginate (page: PaginateBoxPage) {
    const { active, total } = this.props
    const navigationNumbers = paginateUtil.navigationNumbers(active, total)
    const pageNumber = (typeof page === 'number')
      ? page
      : navigationNumbers[page]
    this.props.onPaginate(pageNumber)
  }

  paginateBox (page: PaginateBoxPage) {
    const isActive = (page === this.props.active)
    return (
      <PaginateBox
        page={page}
        active={isActive}
        onClick={this.handlePaginate}
        key={page} />
    )
  }

  get previous () {
    const canShow = this.props.active > 1
    return canShow && this.paginateBox('previous')
  }

  get boxes () {
    const { active, total } = this.props
    const pages = paginateUtil.pages(active, total)
    return pages.map(page => this.paginateBox(page))
  }

  get next () {
    const { active, total } = this.props
    const canShow = active < total - 3
    return canShow && this.paginateBox('next')
  }

  render () {
    return (
      <div className="inline-flex items-center mt-1">
        {this.previous}
        {this.boxes}
        {this.next}
      </div>
    )
  }
}
